import { AutogenLayoutBrokerageWorkflowMasterFile } from "./autogen/AutogenLayoutBrokerageWorkflowMasterFile";

export class BrokerageWorkflowMasterFile extends AutogenLayoutBrokerageWorkflowMasterFile {
}
